import type { DefaultTheme } from 'styled-components';
import { useTheme } from '@wistia/vhs';
import type { HotspotColor } from './types';

const hotspotThemeColor = (theme: DefaultTheme, hotspotColor: HotspotColor): string => {
  switch (hotspotColor) {
    case 'blue':
      return theme.color.brandBlue500;
    case 'green':
      return theme.color.green500;
    case 'pink':
      return theme.color.pink500;
    case 'purple':
      return theme.color.purple500;
    case 'red':
      return theme.color.red500;
    case 'yellow':
      return theme.color.yellow300;
    default:
      return theme.color.pink500;
  }
};

export const useHotspotThemeColor = (hotspotColor: HotspotColor): string => {
  const theme = useTheme();
  return hotspotThemeColor(theme, hotspotColor);
};
